import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SidebarUpgradeProps {
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
}

export function SidebarUpgrade({ isCollapsed, isMobileMenuOpen }: SidebarUpgradeProps) {
  const navigate = useNavigate();

  if (isCollapsed && !isMobileMenuOpen) {
    return (
      <div className="p-4">
        <Button 
          variant="ghost" 
          size="icon" 
          className="w-full bg-purple-100 text-purple-600 hover:bg-purple-200"
          onClick={() => navigate('/admin/conta')}
          title="Seja Premium"
        >
          <Crown className="h-5 w-5" />
        </Button>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="bg-purple-50 border border-purple-100 rounded-xl p-4 text-center">
        <div className="bg-purple-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3">
          <Crown className="h-6 w-6 text-purple-600" />
        </div>
        <h4 className="font-semibold text-purple-800">Seja Premium</h4>
        <p className="text-xs text-purple-600 mt-1 mb-4">
          Desbloqueie recursos ilimitados.
        </p>
        <Button 
          size="sm" 
          className="w-full bg-purple-600 hover:bg-purple-700"
          onClick={() => navigate('/admin/conta')}
        >
          Fazer Upgrade
        </Button>
      </div>
    </div>
  );
}